<template>
  <section>
    <!--工具条-->
    <toolbar
      placeholder="请输入名称"
      :buttonList="buttonList"
      @callFunction="callFunction"
    ></toolbar>

    <!--列表-->
    <el-table
      :data="products"
      v-loading="listLoading"
      highlight-current-row
      style="width: 100%"
      ref="table"
      @select="dialogCheck"
      @row-click="selectCurrentRow"
      class="custom-tbl"
    >
      <el-table-column type="selection" min-width="10"> </el-table-column>
      <el-table-column type="index" label="序号" min-width="10"> </el-table-column>
      <el-table-column prop="coverImage" label="封面" min-width="10">
        <template slot-scope="scope">
          <el-avatar 
            shape="square"
            v-if="scope.row.coverImage"
            :src="scope.row.coverImage.url"
          ></el-avatar>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="商品名称"
        min-width="20" show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="description"
        label="商品简介"
        min-width="20" show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="needIntegral"
        label="兑换所需积分" show-overflow-tooltip
        min-width="10"
      ></el-table-column>
      <el-table-column label="操作" min-width="10">
        <template slot-scope="scope">
          <el-button
            size="mini"
            v-if="canFavorite(scope.row)"
            @click="handleFavorite(scope.row)"
            >收藏</el-button
          >
          <el-button
            size="mini"
            v-if="canUnFavorite(scope.row)"
            @click="handleUnFavorite(scope.row)"
            >取消收藏</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageModel.page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageModel.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageModel.dataCount"
        style="float:right;"
      >
      </el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="editForm"
        label-width="100px"
        :rules="editFormRules"
        ref="editForm"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="商品名称" prop="name">
              <el-input
                v-model="editForm.name"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商品类别" prop="typeId">
              <el-select
                v-model="editForm.typeId"
                clearable
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option v-for="item in productType" :key="item.code" :label="item.value" :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="商品简介" prop="description">
              <el-input
                v-model="editForm.description"
                auto-complete="off"
                type="textarea"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="封面上传" prop="coverImage">
              <ImageFile
                tips="推荐尺寸1:1,大小不超过2M"
                :value="coverImageList"
                :limiCount="1"
                :limitSize="2048"
                @change="coverImageChange"
              ></ImageFile>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="兑换积分" prop="needIntegral">
              <el-input
                v-model.number="editForm.needIntegral"
                auto-complete="off"
                type="number"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="宣传图" prop="contentImage">
              <ImageFile
                tips="推荐尺寸16:9,每张大小不超过2MB,最多允许上传4张"
                :value="contentImageList"
                :limitCount="4"
                :limitSize="2048"
                @change="contentImageChange"
                :isMultiple="true"
              ></ImageFile>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="addForm"
        label-width="100px"
        :rules="addFormRules"
        ref="addForm"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="商品名称" prop="name">
              <el-input
                v-model="addForm.name"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商品类别" prop="typeId">
              <el-select
                v-model="addForm.typeId"
                clearable
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option v-for="item in productType" :key="item.code" :label="item.value" :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="商品简介" prop="description">
              <el-input
                v-model="addForm.description"
                auto-complete="off"
                type="textarea"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="封面上传" prop="coverImage">
              <ImageFile
                tips="推荐尺寸1:1,大小不超过2M"
                :value="coverImageList"
                :limiCount="1"
                :limitSize="2048"
                @change="coverImageChange"
              ></ImageFile>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="兑换积分" prop="needIntegral">
              <el-input
                v-model.number="addForm.needIntegral"
                auto-complete="off"
                type="number"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="宣传图" prop="contentImage">
              <ImageFile
                tips="推荐尺寸16:9,每张大小不超过2MB,最多允许上传4张"
                :value="contentImageList"
                :limitCount="4"
                :limitSize="2048"
                @change="contentImageChange"
                :isMultiple="true"
              ></ImageFile>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "../../../util/date";
import {
  getChildDictionary,
  queryMallProductListPage,
  removeFavorites,
  saveFavorites,
  removeMallProduct,
  saveMallProduct
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import ImageFile from "../../components/ImageFile";
import { DictEnum, FavoritesTypeEnum } from "../../api/enum";

export default {
  components: { Toolbar, ImageFile },
  data() {
    return {
      buttonList: [],
      currentRow: null,
      filter: {
        key: "",
        page: 1,
        pageSize: 10,
      },
      products: [],
      pageModel: {
        pageSize: 10,
        dataCount: 0,
        page: 1,
        pageCount: 0,
      },
      listLoading: false,
      productType: [],
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        name: [
          { required: true, message: "请输入商品名称", trigger: "blur" },
          {
            min: 2,
            max: 50,
            message: "商品名称长度在2到50个字符",
            trigger: "blur",
          },
        ],
        typeId: [
          { required: true, message: "请选择商品类别", trigger: "blur" },
        ],
        description: [
          {
            max: 200,
            message: "简介长度不能超过200个字符",
            trigger: "blur",
          },
        ],
        needIntegral: [
          { required: true, message: "请输入兑换积分", trigger: "blur" },
          { type: "number", message: "兑换积分必须为数字", trigger: "blur" },
        ]
      },
      //编辑界面数据
      editForm: {
        id: "",
        name: "",
        typeId: "",
        description: "",
        needIntegral: 0
      },
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        name: [
          { required: true, message: "请输入商品名称", trigger: "blur" },
          {
            min: 2,
            max: 50,
            message: "商品名称长度在2到50个字符",
            trigger: "blur",
          },
        ],
        typeId: [
          { required: true, message: "请选择商品类别", trigger: "blur" },
        ],
        description: [
          {
            max: 200,
            message: "简介长度不能超过200个字符",
            trigger: "blur",
          },
        ],
        needIntegral: [
          { required: true, message: "请输入兑换积分", trigger: "blur" },
          { type: "number", message: "兑换积分必须为数字", trigger: "blur" },
        ]
      },
      //新增界面数据
      addForm: {
        name: "",
        typeId: "",
        description: "",
        needIntegral: 0,
      },
      coverImageList: [],
      contentImageList: []
    };
  },
  methods: {
    coverImageChange() {},
    contentImageChange() {},
    canFavorite(row) {
      return row.favorite == null;
    },
    handleFavorite(row) {
      if (row.favorite == null) {
        let favorite = {
          objType: FavoritesTypeEnum.Product,
          objId: row.id,
        };
        let formData = new FormData();
        formData.append("model", JSON.stringify(favorite));
        saveFavorites(formData).then((res) => {
          if (res.data.isSuccess) {
            this.$notify({ message: "收藏成功", type: "success" });
            this.handleQuery();
          } else {
            this.$notify({ message: res.data.msg, type: "error" });
          }
        });
      } else {
        this.$notify({
          message: "已收藏过，请勿重复收藏",
          type: "warning",
        });
      }
    },
    canUnFavorite(row) {
      return row.favorite && row.favorite.id > 0;
    },
    handleUnFavorite(row) {
      if (row.favorite && row.favorite.id > 0) {
        let favorite = {
          id: row.favorite.id,
        };
        removeFavorites(favorite).then((res) => {
          if (res.data.isSuccess) {
            this.$notify({ message: "取消收藏成功", type: "success" });
            this.handleQuery();
          } else {
            this.$notify({ message: res.data.msg, type: "error" });
          }
        });
      } else {
        this.$notify({
          message: "当前未收藏",
          type: "warning",
        });
      }
    },
    handleSizeChange(val) {
      this.filter.page = 1;
      this.filter.pageSize = val;
      this.handleQuery();
    },
    handleCurrentChange(val) {
      this.filter.page = val;
      this.handleQuery();
    },
    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    callFunction(item) {
      this.filter.key = item.search;
      this[item.func].apply(this, item);
    },
    handleQuery() {
      this.listLoading = true;
      //NProgress.start();
      queryMallProductListPage(this.filter).then((res) => {
        this.pageModel = res.data.response;
        this.products = res.data.response.data;
        this.listLoading = false;
        //NProgress.done();
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: row.id };
          removeMallProduct(para).then((res) => {
            this.listLoading = false;
            //NProgress.done();
            if (res.data.isSuccess) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.handleQuery();
          });
        })
        .catch(() => {});
    },
    //显示编辑界面
    handleEdit() {
      this.coverImageList = [];
      this.contentImageList = [];
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      if (row.coverImage) {
        this.coverImageList.push(row.coverImage);
      }
      if (row.contentImage) {
        this.contentImageList = row.contentImage;
      }
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
    },
    //显示新增界面
    handleAdd() {
      this.coverImageList = [];
      this.contentImageList = [];
      this.addFormVisible = true;
      this.addForm = {
        name: "",
        typeId: "",
        description: "",
        needIntegral: 0
      };
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            let formData = new FormData();
            formData.append("model", JSON.stringify(this.editForm));
            let covers = this.coverImageList.filter((s) => s.status == "ready");
            if (covers.length > 0) {
              formData.append("coverImage", covers[0].raw);
            }
            let contents = this.contentImageList.filter(
              (s) => s.status == "ready"
            );
            if (contents.length > 0) {
              contents.forEach((element) => {
                formData.append("contentImages", element.raw);
              });
            }
            saveMallProduct(formData).then((res) => {
              this.editLoading = false;
              if (res.data.isSuccess) {
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.coverImageList = [];
                this.contentImageList = [];
                this.editFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function () {
      let _this = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            let formData = new FormData();
            formData.append("model", JSON.stringify(this.addForm));
            let covers = this.coverImageList.filter((s) => s.status == "ready");
            if (covers.length > 0) {
              formData.append("coverImage", covers[0].raw);
            }
            let contents = this.contentImageList.filter(
              (s) => s.status == "ready"
            );
            if (contents.length > 0) {
              contents.forEach((element) => {
                formData.append("contentImages", element.raw);
              });
            }
            saveMallProduct(formData).then((res) => {
              this.addLoading = false;
              if (res.data.isSuccess) {
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.coverImageList = [];
                this.contentImageList = [];
                this.addFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    initProductType() {
      getChildDictionary({ code: DictEnum.ProductType }).then((res) => {
        if (res.data.isSuccess) {
          this.productType = res.data.response;
        }
      });
    },
  },
  mounted() {
    this.handleQuery();
    this.initProductType();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}
</style>
